<template>
  <v-container class="mt-12 pt-8" style="background:#fafafa;">
    <v-row style="background:#fafafa;">
      <v-col cols="12" md="12" class="pa-0">
        <v-row class="py-1 px-5">
          <v-col cols="12" md="12">
            <v-row>
              <v-col cols="12" class="px-5" PANNELS>
                <v-card NotificationPanel :loading="loading">
                  <v-card-text class="py-0">
                    <v-row class="align-center">
                      <v-col cols="12" :class="`${arabic?'arFont':'enFont'} text-center`">
                        الكورسات المتوفرة للتسجيل لك
                      </v-col>
                      <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`">
                        <v-row class="align-center" v-if="resource.data">
                          <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`" v-for="(course, c) in resource.data" :key="'course'+c">
                            <v-card class="px-3">
                              <v-row class="align-center">
                                <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`">
                                  إسم الكورس: 
                                  <v-chip label dark color="primary" :class="`${arabic?'arFont':'enFont'}`">{{course.name}}</v-chip>
                                </v-col>
                                <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`">
                                  المستوى: 
                                  <v-chip label dark color="primary" :class="`${arabic?'arFont':'enFont'}`">{{course.level_name.ar}}</v-chip>
                                </v-col>
                                <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`">
                                  تاريخ البداية: 
                                  <v-chip label dark color="primary" :class="`${arabic?'arFont':'enFont'}`">{{course.start_date.split(' ')[0]}}</v-chip>
                                </v-col>
                                <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`">
                                  تاريخ النهاية: 
                                  <v-chip label dark color="primary" :class="`${arabic?'arFont':'enFont'}`">{{course.finish_date.split(' ')[0]}}</v-chip>
                                </v-col>
                                <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`">
                                  ايام الدراسة: 
                                  <v-chip label dark color="primary" :class="`${arabic?'arFont':'enFont'}`">{{course.daysar.join(' | ')}}</v-chip>
                                </v-col>
                                <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`">
                                  وقت الدراسة: 
                                  <v-chip label dark color="primary" :class="`${arabic?'arFont':'enFont'}`">{{course.time}}</v-chip>
                                </v-col>
                              </v-row>
                              <v-card-actions v-if="!loading">
                                <v-spacer></v-spacer>
                                <v-btn color="success" :class="`${arabic?'arFont':'enFont'}`" @click="()=>{selectedCourse=course;dialog=true;}">
                                  حجز هذا الكورس 
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <registerDialog
      :dialog="dialog"
      :loading="loading"
      :course="selectedCourse"
      @closeDialog="()=>{dialog=false;selectedCourse=null}"
      @registerCourse="registerCourse"
    />
  </v-container>
</template>
<script>
import axios from 'axios';
const headers = {'Accept': 'application/json'};
import registerDialog from '@/components/registerDialog'

export default {
  components: {registerDialog},
  data() {
    return {
      loading:false,
      dialog:false,
      resource:{},
      selectedCourse:null,
    }
  },
  methods: {
    
    goTo(path) {
      this.$router.push(path).catch(x=>{})
    },
    async registerCourse(course){
      return new Promise(async (res, rej)=>{
        this.loading = true
        try {
          let s = await this.$store.dispatch('postResource', {resource:'/registercourse', value:course})
          let a = await this.$store.dispatch('getUser')
          this.$emit('snackbarNotification', `تم التسجيل بنجاح`, 'success')
        } catch (error) {}  
        this.dialog = false
        this.loading = false
        this.goTo('/dashboard')      
        res(true)
      })
    },
    async init(){
      return new Promise(async (res, rej)=>{
        this.loading = true
        if(!this.user.language_access) {
          this.goTo('/dashboard')
        }
        let call = await this.$store.dispatch('getResource', {resource:'/getcourses'})
        call.data = call.data.filter(x=> x.candidates_count < parseInt(x.limit))
        this.resource = call
        console.log(this.resource)
        this.loading = false
        res(true)
      })
    }
    
  },
  computed:{
    progress(){
      return (this.visible + this.prev_progress)/69 * 100
    },
    questions(){
      return this.quiz
    },
    cc(){
      return this.$store.state.cc
    },
    api(){
      return this.$store.state.settings.apiBase
    },
    users(){
      let sa = this.$store.state.user && this.$store.state.user.role == 'superadmin'
      // console.log(sa)
      return this.$store.state.users.filter(x=>{
        if(!sa) {
          return x.superior == this.$store.state.user.level
        } else return x
      })
    },
    site(){
      return this.$store.state.site
    },
    items() {
      const items = [...this.$store.state.modelMenu]
      let user = {...this.$store.state.user}
      let role = user.role
      this.$store.menu = items.map(x=>{
        if(x.subs) {
          return {
            ...x, 
            subs:x.subs.filter(x=>x&&x.roles.includes(role))
          }
        } else if(x&&x.roles.includes(role)) {
          return {
            ...x
          }
        }
      }).filter(x=>x&&x.roles.includes(role))
      return this.$store.menu
    },
    superAdmin(){
      return this.$store.state.superAdmin
    },
    isLogin() {
      return this.$store.state.centralLogin
    },
    language(){
      return this.$store.state.language
    },
    globalLoading(){
      return this.$store.state.globalLoading
    },
    user(){
      return this.$store.state.user
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    routeTitle(){
      let main = this.$store.state.menu.filter(x=>x.path == this.$route.path)
      let sub = [].concat(...this.$store.state.menu.map(x=>x.subs)).filter(x=>x).filter(x=>x.path == this.$route.path)
      if(main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text]
      } else if(sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text]
      } else {
        return ''
      }
    },
    roles(){
      return this.$store.state.userRoles
    },
    notifications(){
      return this.$store.state.notifications
    },
    // countries(){
    //   return this.$store.state.countries
    // },
    country(){
      return this.$store.state.country
    },
  },
  watch:{
    
  },
  async created(){
    await this.init()
  },
}
</script>

<style>
.flagBtn {
  height: 80px !important;
}
</style>